import { render } from "./UpdateStudentStandartCarrying.vue?vue&type=template&id=7c01f579"
import script from "./UpdateStudentStandartCarrying.vue?vue&type=script&lang=js"
export * from "./UpdateStudentStandartCarrying.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__